import { styled } from "styled-components";

import { UIInput } from "common/components/form/UIInput";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { DimensionsList } from "domains/createMapDetail/components/keyIssueList/DimensionsList";
import { toggleCustomKeyIssueForm } from "domains/customKeyIssue/actions";
import { CreateCustomKeyIssueButton } from "domains/customKeyIssue/components/CreateCustomKeyIssueButton";
import { dimensionSlice } from "domains/dimension/dimension.slice";
import { pushModalScreen } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getCanAccessCreate, getCreateMapCustomKeyIssueAccess } from "entities/permissions/selectors";

const StyledDimensionsList = styled(DimensionsList)`
  padding-right: 0;
`;

const StyledSearchInput = styled(UIInput)`
  margin-bottom: 1rem;
`;

export const DimensionsModal = () => {
  const dispatch = useDispatch();
  const canAccessCreate = useSelector(getCanAccessCreate);
  const canCreateCustomKeyIssue = useSelector(getCreateMapCustomKeyIssueAccess);
  const search = useSelector((state) => state.dimension.search);
  const translate = useTranslate();

  const onChange = (value: string) => dispatch(dimensionSlice.actions.setSearch(value));

  const onEditKeyIssueSelect = (id?: string) => {
    if (canCreateCustomKeyIssue) {
      dispatch(toggleCustomKeyIssueForm({ id, isActive: true }));
      dispatch(pushModalScreen({ id: "AddCustomDimension" }));
    } else {
      dispatch(pushModalScreen({ id: "CreateCustomDimensionUpgrade" }));
    }
  };

  const addButton = <CreateCustomKeyIssueButton onAdd={onEditKeyIssueSelect} showStarIcon={!canCreateCustomKeyIssue} />;

  return !canAccessCreate ? null : (
    <>
      <ModalHeader rightElement={addButton} title={translate("app.topic.key_issues")} />
      <StyledSearchInput clear={() => onChange("")} onChange={onChange} value={search ?? ""} />
      <StyledDimensionsList onEditKeyIssueSelect={onEditKeyIssueSelect} />
    </>
  );
};
